import { NgxLoggerLevel } from 'ngx-logger';

// Environment for DEPLOYED develop (not local emulators)
// This file is used when building with --configuration=development for deployment

export const environment = {
  env: 'develop',
  production: false,
  useServiceWorker: false,
  useEmulators: false,  // Set to false for deployed develop cloud

  isDockerized: false,
  fileServerBaseUrlTimeLine: '//localhost:4200/',
  mediaServerBaseUrlTimeLine: '//localhost:4200/',
  fileServerBaseUrl: 'api/',
  mediaServerBaseUrl: 'api/',
  logServerUrl: '',
  logLevel: NgxLoggerLevel.DEBUG,
  logServerLevel: NgxLoggerLevel.INFO,
  firebase: {
    apiKey: "AIzaSyAGG9phd2ujUZxxMrikl5WRFnxZXkZJ90A",
    authDomain: "dev.newgenus.org",
    databaseURL: "https://newgenus-dev-19da7.firebaseio.com",
    projectId: "newgenus-dev-19da7",
    storageBucket: "newgenus-dev-19da7.appspot.com",
    messagingSenderId: "1040159889146",
    appId: "1:1040159889146:web:3e24ebacaf9690b6f59b43",
    measurementId: "G-3ZJE5R4FCH"
  },
  emulator_config: {
    region: 'us-central1',
    url: 'http://localhost:5001/newgenus-dev-19da7/us-central1/api-',
    azureOauthLink: 'http://localhost:5001/newgenus-dev-19da7/us-central1/api-securityToolsAzure-oauth/donkey-boy-init',
    gmailOauthLink: 'http://localhost:5001/newgenus-dev-19da7/us-central1/api-securityToolsOauth2Init-default',
    useAuthEmulator: false
  },
  gcp: {
    oauthLink: 'https://us-central1-newgenus-dev-19da7.cloudfunctions.net/api-securityToolsOauth2Init-default',
    toolsOauthInit: 'https://us-central1-newgenus-dev-19da7.cloudfunctions.net/api-securityToolsOauth2Init-default',
    baseUrl: 'https://us-central1-newgenus-dev-19da7.cloudfunctions.net/api-'
  },
  azure: {
    oauthLink: 'https://us-central1-newgenus-dev-19da7.cloudfunctions.net/api-securityToolsAzure-oauth/donkey-boy-init'
  },
  issuesFirebase: {
    projectId: 'newgenus-issues',
    apiKey: 'AIzaSyD7Q5GCP051x8y_9ODPEr_YD2g_8nlFWSg',
    authDomain: 'newgenus-issues.firebaseapp.com',
    storageBucket: 'newgenus-issues.firebasestorage.app',
    messagingSenderId: '272348268157',
    appId: '1:272348268157:web:1f99d75e9f17157c07d314',
    exchangeUrl: 'https://us-central1-newgenus-issues.cloudfunctions.net/exchangeToken'
  }
};
